import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { minHeightDvh } from '../../../theme/mixins';

export const pageWrapperStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...minHeightDvh('60dvh'),
    py: 6,
};

export const cardStyles: SxProps<Theme> = {
    width: '100%',
    maxWidth: 460,
    borderRadius: 4,
    p: 1,
};

export const titleStyles: SxProps<Theme> = { fontWeight: 700, mb: 1 };

export const subtitleStyles: SxProps<Theme> = { color: 'text.secondary', mb: 3 };

export const alertStyles: SxProps<Theme> = { mb: 2, borderRadius: 3 };

export const fieldsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mb: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    py: 4,
};

export const submitButtonStyles: SxProps<Theme> = { py: 1.25, fontWeight: 600 };
